<template>
    <div
        class="rounded-lg shadow-sm flex flex-row gap-3 pl-3 pr-4 min-h-18 items-center"
        :class="{
            'bg-gray-300 text-gray-700': props.activationStatus === 'Inactive',
            'bg-gray-50 text-gray-500': props.activationStatus === 'Active',
            'bg-red-50 text-gray-500': props.activationStatus === 'Deactivated',
        }"
    >
        <PersonInfo
            :name="`${props.lastName}, ${props.firstName}`"
            :job-title="props.jobTitle"
            :company="props.company"
            :variant="props.activationStatus"
            :link-target="linkTarget"
        >
            <template #avatar>
                <div
                    v-if="props.activationStatus === 'Deactivated'"
                    class="rounded-full bg-red-200 size-12 text-red-700 flex items-center justify-center shrink-0"
                >
                    <BlockIcon class="size-6" />
                </div>
                <img
                    v-else-if="props.activationStatus === 'Active' && props.avatarUrl"
                    :src="props.avatarUrl"
                    alt=""
                    class="rounded-full size-12 object-cover shrink-0"
                />
                <InitialsWithBackground
                    v-else
                    class="size-12 leading-12 shrink-0"
                    :first-name="props.firstName"
                    :last-name="props.lastName"
                    :variant="props.activationStatus === 'Inactive' ? 'Gray' : 'Default'"
                />
            </template>
        </PersonInfo>

        <div class="flex flex-row gap-2">
            <slot name="loginmethods" />
        </div>

        <div class="flex flex-row gap-2 ml-2">
            <slot name="permissions" />
        </div>

        <div class="grow" />

        <div class="flex flex-row gap-2">
            <slot name="buttons" />
        </div>
    </div>
</template>

<script setup lang="ts">
import InitialsWithBackground from '@/user/components/InitialsWithBackground.vue';
import { RouteLocationRaw } from 'vue-router';
import BlockIcon from '../Icon/BlockIcon.vue';
import PersonInfo, { type ActivationStatus } from '../PersonInfo/PersonInfo.vue';

export type UserCardActivationStatus = ActivationStatus;

type UserCardProps = {
    company?: {
        name: string;
        type: 'Koelnmesse' | 'Koelncongress' | 'Other';
    };
    firstName: string;
    lastName: string;
    jobTitle?: string;
    activationStatus: UserCardActivationStatus;
    avatarUrl?: string;
    linkTarget?: RouteLocationRaw;
};

const props = defineProps<UserCardProps>();
</script>
